import { Building2, ChevronLeft, ChevronRight } from 'lucide-react';
import { NotificationBell } from '@/components/Dashboard/NotificationBell';
import { UserProfileMenu } from '@/components/Dashboard/UserProfileMenu';
import { CompanySwitcher } from '@/components/Layout/CompanySwitcher';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { useStableAuth } from '@/hooks/useStableAuth';

interface AppHeaderProps {
  collapsed: boolean;
  onToggleCollapsed: () => void;
}

// UI-HEADER-FIXO (I.160, Diretor 23/10; ajuste da tarde e ajuste 2 da noite): barra na largura inteira, no alto da página
// (não gruda: sobe junto ao rolar); 60 px no celular e 72 px no desktop; à esquerda o botão de recolher o menu, o logo e o
// nome da empresa numa linha (e o seletor de empresas do grupo, quando houver); à direita o sino e o menu do usuário
// (avatar com o nome, sem a empresa). No celular, nome da empresa e do usuário somem.
export const AppHeader = ({ collapsed, onToggleCollapsed }: AppHeaderProps) => {
  const { profile, signOut, company } = useStableAuth();

  return (
    <header className="flex h-[60px] w-full items-center gap-2 border-b border-border bg-background px-3 sm:h-[72px] sm:gap-3 sm:px-4">
      <Button
        variant="ghost"
        size="sm"
        onClick={onToggleCollapsed}
        className="shrink-0"
        aria-label={collapsed ? 'Abrir menu' : 'Recolher menu'}
      >
        {collapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
      </Button>
      <div className="w-11 h-11 sm:w-14 sm:h-14 shrink-0 bg-primary/10 rounded-lg flex items-center justify-center overflow-hidden">
        {company?.logo_url ? (
          <img src={company.logo_url} alt="Logo da empresa" className="w-full h-full object-cover" />
        ) : (
          <Building2 className="h-6 w-6 text-primary" />
        )}
      </div>
      <h1
        className="hidden sm:block min-w-0 text-2xl font-bold text-primary whitespace-nowrap overflow-hidden text-ellipsis"
        title={company?.name || 'GOnX'}
      >
        {company?.name || 'GOnX'}
      </h1>
      <div className="hidden md:block">
        <CompanySwitcher />
      </div>
      <div className="ml-auto flex items-center gap-2 sm:gap-3">
        <NotificationBell />
        <Separator orientation="vertical" className="h-8" />
        <UserProfileMenu
          fullName={profile?.full_name}
          email={profile?.email}
          avatarUrl={profile?.avatar_url}
          onSignOut={signOut}
        />
      </div>
    </header>
  );
};
